var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWellnessQualityOfLife(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6277 7.78601C12.1513 9.26234 9.66005 9.26234 8.18375 7.78601",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82961 5.33509C8.46052 5.15055 7.90689 5.05828 7.35327 5.15055C6.79965 5.24282 6.3383 5.51963 6.06149 5.88871",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1664 5.2428C13.5355 5.05826 14.089 4.96599 14.6426 5.05826C15.1963 5.15053 15.6576 5.42734 15.9344 5.79643",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6104 12.6706C18.2413 13.9623 17.4109 15.1619 14.9196 15.6232C13.7201 15.8078 13.2587 17.2841 14.5505 17.6532C12.1201 17.6532 13.0726 21.5093 15.57 20.8263C19.446 19.7663 21.4708 14.7651 21.4708 11.1481C21.4708 5.42733 16.8572 0.813812 11.1365 0.813812C5.41575 0.813812 0.894379 5.42733 0.894379 11.1481C0.894379 14.7651 2.91915 19.7663 6.79515 20.8263C9.29255 21.5093 10.2451 17.6532 7.81465 17.6532C9.10643 17.2841 8.64507 15.8078 7.44556 15.6232C4.95426 15.1619 4.12382 13.9623 3.75474 12.6706",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18167 12.6949C6.33238 12.1501 6.66099 11.6572 7.12656 11.3151C8.64154 10.2022 10.0288 11.1583 11.1352 12.2647C12.2448 11.1611 13.6309 10.199 15.1475 11.3145C15.6128 11.6567 15.941 12.1499 16.0915 12.6949",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04575 18.2536C9.61826 18.687 10.2875 19.3057 10.9729 19.5564C11.0277 19.5765 11.0862 19.5862 11.1451 19.585C11.2038 19.5838 11.2619 19.5719 11.3158 19.5496C12.0749 19.2371 12.8367 18.5371 13.472 18.028",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1449,
    height: 22.1449,
    fill: "currentColor",
    transform: "translate(0.0640259 0.121796)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessQualityOfLife);
export default __webpack_public_path__ + "static/media/wellness_quality_of_life.d4ccb846.svg";
export { ForwardRef as ReactComponent };